/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/locationMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Location. */
export class Location {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Location.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Looks up the ISO country/region code using the remote IP address.
   * @summary Returns the ISO country/region code based on the IP address of the caller.
   * @param [options] The optional parameters
   * @returns Promise<Models.LocationGetISOCountryOrRegionCodeResponse>
   */
  getISOCountryOrRegionCode(options?: coreHttp.RequestOptionsBase): Promise<Models.LocationGetISOCountryOrRegionCodeResponse>;
  /**
   * @param callback The callback
   */
  getISOCountryOrRegionCode(callback: coreHttp.ServiceCallback<Models.IPAddressLocation>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getISOCountryOrRegionCode(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.IPAddressLocation>): void;
  getISOCountryOrRegionCode(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.IPAddressLocation>, callback?: coreHttp.ServiceCallback<Models.IPAddressLocation>): Promise<Models.LocationGetISOCountryOrRegionCodeResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getISOCountryOrRegionCodeOperationSpec,
      callback) as Promise<Models.LocationGetISOCountryOrRegionCodeResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getISOCountryOrRegionCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/Location",
  responses: {
    200: {
      bodyMapper: Mappers.IPAddressLocation
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
